/* Original name @uswitch/trustyle.social-sharing */

import React from 'react'
import { Themed } from 'theme-ui'
import { TruFacebook, TruTwitter, TruLinkedIn, TruEmail } from '@uswitch/spark-icons/tru'

const SocialSharing = ({
  className = '',
  labelText = 'Share this guide',
  shareUrl,
  twitterMessage,
  mailSubject,
}) => {
  const styles = element => `compounds.social-sharing.${element}`

  const encodedShareUrl = encodeURIComponent(shareUrl)

  return (
    <Themed.div
      className={className}
      sx={{
        variant: styles('main'),
      }}
    >
      {(labelText && (
        <Themed.div
          sx={{
            variant: styles('label'),
          }}
        >
          {labelText}
        </Themed.div>
      )) ||
        ''}

      <Themed.div
        sx={{
          variant: styles('buttons'),
        }}
      >
        <Themed.a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodedShareUrl}`}
          target='_blank'
          sx={{
            textDecoration: 'none',
            cursor: 'pointer',
            borderBottom: 0,
            variant: styles('fb'),
          }}
        >
          <TruFacebook size={20} color='#1877f2' />
        </Themed.a>
        <Themed.a
          href={`https://twitter.com/intent/tweet?${
            twitterMessage ? `text=${encodeURIComponent(twitterMessage)}` : `url=${encodedShareUrl}`
          }`}
          target='_blank'
          sx={{
            textDecoration: 'none',
            cursor: 'pointer',
            borderBottom: 0,
            variant: styles('tw'),
          }}
        >
          <TruTwitter size={20} color='#1d9bf0' />
        </Themed.a>
        <Themed.a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedShareUrl}`}
          target='_blank'
          sx={{
            textDecoration: 'none',
            cursor: 'pointer',
            borderBottom: 0,
            variant: styles('ln'),
          }}
        >
          <TruLinkedIn size={24} color='#2867b2' />
        </Themed.a>
        <Themed.a
          href={`mailto:?subject=${encodeURIComponent(mailSubject)}&body=${encodedShareUrl}`}
          sx={{
            textDecoration: 'none',
            cursor: 'pointer',
            borderBottom: 0,
            variant: styles('email'),
          }}
        >
          <TruEmail size={16} color='primary' />
        </Themed.a>
      </Themed.div>
    </Themed.div>
  )
}

export default SocialSharing
